export default function CoordinatorList({
  assessment,
  tests = [],
  givenPoints = {},
  handleGivePoints,
  handleReview,
  isSubmitting = false,
}) {
  const identificationAnswers = tests.filter(
    (test) =>
      test.userId === assessment.user_id &&
      test.testId === assessment.test_id &&
      test.questionType === "Identification"
  );

  return (
    <article
      className="assessmentDiv"
      aria-labelledby={`assessment-${assessment.user_id}-${assessment.test_id}`}
    >
      <div className="assessmentSummaryCard">
        <h2
          id={`assessment-${assessment.user_id}-${assessment.test_id}`}
        >
          Assessment Review
        </h2>

        <p>
          <strong>User ID:</strong>{" "}
          {assessment.user_id}
        </p>

        <p>
          <strong>Test ID:</strong>{" "}
          {assessment.test_id}
        </p>

        <p>
          <strong>Ready for Coordinator?</strong>{" "}
          {assessment.ready_for_coordinator ? "Yes" : "No"}
        </p>

        <p>
          <strong>Ready to Create PDF?</strong>{" "}
          {assessment.ready_to_send_to_leader
            ? "Yes"
            : "No"}
        </p>

        <p>
          <strong>Sent?</strong>{" "}
          {assessment.sent ? "Yes" : "No"}
        </p>

        <p>
          <strong>Knowledge Score:</strong>{" "}
          {assessment.knowledge_score ?? 0}
        </p>

        <p>
          <strong>Current Identification Score:</strong>{" "}
          {assessment.identify_score ?? 0}
        </p>
      </div>

      <h3 className="identificationAnswersTitle">
        Identification Answers
      </h3>

      <div className="identificationAnswersList">
        {identificationAnswers.length === 0 ? (
          <p className="fourHEmptyMessage">
            No identification answers were found.
          </p>
        ) : (
          identificationAnswers.map((test) => {
            const rawUserAnswer = Array.isArray(
              test.uAnswer
            )
              ? test.uAnswer[0]
              : test.uAnswer;

            const userAnswer =
              typeof rawUserAnswer === "string"
                ? rawUserAnswer.trim()
                : "";

            const userAnswered = Boolean(userAnswer);
            const answerKey = `${assessment.user_id}-${test.questionId}`;
            const alreadyCorrect =
              Number(test.points) >= 1;

            return (
              <div
                className="coordinatorUserAnswerReview"
                key={`${assessment.user_id}-${test.questionId}`}
              >
                <p>
                  <strong>Question:</strong>{" "}
                  {test.questionId}
                </p>

                <p>
                  <strong>User Answer:</strong>{" "}
                  {userAnswered ? (
                    userAnswer
                  ) : (
                    <em className="wrongAnswer">
                      User Did Not Answer
                    </em>
                  )}
                </p>

                <p>
                  <strong>Correct Answer:</strong>{" "}
                  {test.cAnswer}
                </p>

                {!alreadyCorrect && userAnswered ? (
                  givenPoints[answerKey] ? (
                    <p className="userCorrectP">
                      Points Awarded
                    </p>
                  ) : (
                    <button
                      className="givePointsButton"
                      type="button"
                      onClick={() =>
                        handleGivePoints(
                          assessment.user_id,
                          test.questionId
                        )
                      }
                    >
                      Give Points
                    </button>
                  )
                ) : (
                  <p
                    className={
                      alreadyCorrect
                        ? "userCorrectP"
                        : "userIncorrectP"
                    }
                  >
                    {alreadyCorrect
                      ? "User Answered Correctly"
                      : "Cannot Give Points"}
                  </p>
                )}
              </div>
            );
          })
        )}
      </div>

      <button
        type="button"
        className="submitUserUpdateButton"
        onClick={() => handleReview(assessment)}
        disabled={isSubmitting}
      >
        {isSubmitting ? "Saving..." : "Reviewed"}
      </button>
    </article>
  );
}